/* eslint-disable */
<template>
  <div>
      <app-cabin :title="title" :description="description" :slides="slides" :imgDir="imgDir" :facebookUrl="facebookUrl" :vrboUrl="vrboUrl" ></app-cabin>
  </div>
</template >

<script>
import Cabin from './shared/Cabin';

export default {
  components:{
    'app-cabin': Cabin
  },
  data() {
    return {
          title: 'Horse Nest',
          description: '<h2>Luxury Studio Cabin/Hot Tub/Fireplace</h2><br>Horse Nest is a beautiful Luxury Studio Cabin nestled in beautiful and Peaceful Surroundings. Joining the Ouachita National Forest. Enjoy the Fully Equipt Kitchen or Cook Outside on the Grill and Eat around the Fire Pit or Next to the Beautiful Outdoor Fireplace. Then Relax Next To The Fire In The Awesome Hot Tub, Or play A Game Of Horseshoes. It has a Large King Size Bed, Large Flat Screen TVs and Gaming Console. Relax in Comfort beside the 2 Sided Fireplace. Private, yet close to all the Fun, Restaurants, Golf Coarse and Marina. Horse Nest was built for Two People to get away From it all. But it does have a small loft that can sleep a couple of kids if You can not find a Sitter and Want To Have A Family Stay!!!<br>For more information contact Denise Gentry <a href="tel:870-852-1590">(870) 852-1590</a>',
          slides: [],
          imgDir: '../assets/cabins/horse-nest/',
          facebookUrl: '',
          vrboUrl: 'https://www.vrbo.com/1575318'
    };
  },
  mounted() {
    this.importAll(require.context('../assets/cabins/horse-nest/', true, /\.jpg$/));
  },
    methods:{
      importAll(r) {
        r.keys().forEach(key => (this.slides.push({ src: r(key), name: key })));
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
img {
  height: 200px;
  object-fit: contain;
}
p{
  margin-left: 400px;
  margin-right: 100px;
}
.myDiv {
background-color:lightgray;
}
</style>



// WEBPACK FOOTER //
// src/components/HorseNest.vue